export const CAUSE_COLORS = {
  environment: "#4A6B53",
  humanitarianism: "#D96C4A",
  social_justice: "#7C4A6B",
  animal_welfare: "#B37A2C",
  education: "#2C5F7C",
  health_wellness: "#5E8A5F",
  arts_culture: "#A8533F",
  community_development: "#4D5E7A",
};

export const CAUSE_NAMES = {
  environment: "Environment & Climate",
  humanitarianism: "Humanitarian Relief",
  social_justice: "Social Justice",
  animal_welfare: "Animal Welfare",
  education: "Education & Mentorship",
  health_wellness: "Health & Wellness",
  arts_culture: "Arts & Culture",
  community_development: "Community Development",
};

export const MARKETPLACE_CATEGORY_LABELS = {
  tutoring: "Tutoring & Lessons",
  creative: "Creative",
  wellness: "Wellness",
  home_help: "Home Help",
  tech: "Tech & Admin",
  goods: "Goods",
  events: "Events",
  other: "Other",
};
